import * as Yup from 'yup';

export interface IImpressaoOficioSegundaViaPlaca {
	numeroFicha: string;
	anoFicha: string;
}

export const initialValues: IImpressaoOficioSegundaViaPlaca = {
	numeroFicha: '',
	anoFicha: '',
};

export const schema = Yup.object<IImpressaoOficioSegundaViaPlaca>().shape({
	numeroFicha: Yup.string().required(`Campo Obrigatório: Número da Ficha.`),
	anoFicha: Yup.string().required(`Campo Obrigatório: Ano da Ficha Cadastral.`),
});
